module.exports = __webpack_public_path__ + "img/gmb_logo_ru.svg";